import type { InternalSkuStatusResponse } from '@nadoutong/contracts';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../hooks/useSession.tsx';
import { getSkuStatus } from './skuStatus.ts';

const SKU_STATUS_KEY = ['sku-status'] as const;

/**
 * Epic #898 P6 (#910): SKU status snapshot + buckets for the detail-page
 * sparkline. Callers hide the card when `snapshot` is null and `buckets`
 * is empty (no rollup has seen the SKU yet).
 */
export function useSkuStatus(skuId: string | null): UseQueryResult<InternalSkuStatusResponse> {
  const { fetchImpl } = useSession();
  return useQuery({
    queryKey: [...SKU_STATUS_KEY, skuId ?? ''],
    queryFn: ({ signal }) => {
      if (skuId === null || skuId.length === 0) {
        throw new Error('useSkuStatus: skuId is required');
      }
      return getSkuStatus(skuId, fetchImpl, signal);
    },
    enabled: skuId !== null && skuId.length > 0,
  });
}
